import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
  } from 'chart.js';
import '../../../scss/app.scss';
import "react-toggle/style.css"
import { Card, CardContent } from '@mui/material';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

export function RecentUsage({ bills, meterConfigs }) {
    const graphColor = ["blue", "orange", "green"];
    const [data, setData] = useState<any[]>([]);
    const [legend, setLegend] = useState<any[]>([]);
    const options = {
        plugins: {
            legend: {
              display: false
            },
        },
        responsive: true,
        interaction: {
          mode: 'index' as const,
          intersect: false,
        },
        parsing: {
            xAxisKey: "month",
            yAxisKey: "usage",
        },
        scales: {
            x: {
              stacked: false,
            },
            y: {
              stacked: false,
            },
        },
    };

    useEffect(() => {
        let datasets: any[] = [];
        let legendSet = new Set<string>();
        if(bills){
            if(bills.some(x => x.waterUsage !== null))
            {
                datasets.push({
                    label: `Water ${meterConfigs?.waterDisplayUnits ?? ""}`,
                    data: bills.map(x => {
                        let date = new Date(x.billingCycle.billDate);
                        legendSet.add(`${date.toLocaleDateString()}`);
                        return {
                            usage: x.waterUsage,
                            month: `${date.toLocaleDateString()}`,
                        }
                    }),
                    backgroundColor: graphColor[0],
                })
            }
            if(bills.some(x => x.electricityUsage !== null))
            {
                datasets.push({
                    label: `Electric ${meterConfigs?.electricityDisplayUnits ?? ""}`,
                    data: bills.map(x => {
                        let date = new Date(x.billingCycle.billDate);
                        legendSet.add(`${date.toLocaleDateString()}`);
                        return {
                            usage: x.electricityUsage,
                            month: `${date.toLocaleDateString()}`,
                        }
                    }),
                    backgroundColor: graphColor[1],
                })
            }
            if(bills.some(x => x.gasUsage !== null))
            {
                datasets.push({
                    label: `Gas ${meterConfigs?.gasDisplayUnits ?? ""}`,
                    data: bills.map(x => {
                        let date = new Date(x.billingCycle.billDate);
                        legendSet.add(`${date.toLocaleDateString()}`);
                        return {
                            usage: x.gasUsage,
                            month: `${date.toLocaleDateString()}`,
                        }
                    }),
                    backgroundColor: graphColor[2],
                })
            }
            if(bills.some(x => x.fireLineUsage !== null))
                {
                    datasets.push({
                        label: `Fire Line ${meterConfigs?.fireLineDisplayUnits ?? ""}`,
                        data: bills.map(x => {
                            let date = new Date(x.billingCycle.billDate);
                            legendSet.add(`${date.toLocaleDateString()}`);
                            return {
                                usage: x.fireLineUsage,
                                month: `${date.toLocaleDateString()}`,
                            }
                        }),
                        backgroundColor: graphColor[0],
                    })
                }
                if(bills.some(x => x.sprinklerUsage !== null))
                    {
                        datasets.push({
                            label: `Sprinkler ${meterConfigs?.sprinklerDisplayUnits ?? ""}`,
                            data: bills.map(x => {
                                let date = new Date(x.billingCycle.billDate);
                                legendSet.add(`${date.toLocaleDateString()}`);
                                return {
                                    usage: x.sprinklerUsage,
                                    month: `${date.toLocaleDateString()}`,
                                }
                            }),
                            backgroundColor: graphColor[0],
                        })

        }
        setData(datasets)
        setLegend(Array.from(legendSet))
    }}, [bills])// eslint-disable-line react-hooks/exhaustive-deps

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Tooltip,
        Legend
    )

    return (
        <Card className='usage-card'>
            <CardContent style={{padding: '0px 10px 5px 10px', fontSize: "1.2em"}}>
                {data.length > 0 ?
                    <CarouselProvider
                        interval={10000}
                        naturalSlideWidth={100}
                        naturalSlideHeight={33}
                        totalSlides={data.length}
                        isPlaying={true}
                        infinite={true}
                        >
                        <Slider className='usage-slider'>
                            {data?.map((e, i) => (
                                <Slide key={i} index={i-1} aria-label={`${e.label} chart slide`}>
                                    <h5 style={{color:"black"}}>{e.label}</h5>
                                    <Bar aria-label={`${e.label} usage chart`} style={{maxHeight: "150px", display: "block", width: "90%" }} options={options} data={{
                                        labels: legend,
                                        datasets: [e]
                                    }} />
                                </Slide>)
                            )}
                        </Slider>
                        {data.length > 1 &&
                            <>
                                <ButtonBack aria-label="Back - Previous slide">Back</ButtonBack>
                                <ButtonNext aria-label="Next - Next slide">Next</ButtonNext>
                            </>
                        }
                    </CarouselProvider> :
                    <div style={{ textAlign: "center" }}>
                        <h1 style={{ fontWeight: "400", fontSize: "1.8em", marginTop: "11px", marginBottom: "13px" }}>Usage Unavailable</h1>
                        <p>There is no usage data available for this account.</p>
                    </div>}
            </CardContent>
        </Card>
        )

}
